import Assets from '@/views/websites/Assets.vue'
import Asset from '@/views/websites/Asset.vue'
import Complexes from '@/views/websites/Complexes.vue'
import ComplexesActivate from '@/views/websites/ComplexesActivate.vue'
import Complex from '@/views/websites/Complex.vue'
import Images from '@/views/websites/Images.vue'
import Image from '@/views/websites/Image.vue'
import Namespaces from '@/views/websites/Namespaces.vue'
import Namespace from '@/views/websites/Namespace.vue'
import NavItems from '@/views/websites/NavItems.vue'
import NavItem from '@/views/websites/NavItem.vue'
import Pages from '@/views/websites/Pages.vue'
import Page from '@/views/websites/Page.vue'
import Redirections from '@/views/websites/Redirections.vue'
import Redirection from '@/views/websites/Redirection.vue'
import Strings from '@/views/websites/Strings.vue'
import String from '@/views/websites/String.vue'
import StringCategories from '@/views/websites/StringCategories.vue'
import StringCategory from '@/views/websites/StringCategory.vue'
import Tags from '@/views/websites/Tags.vue'
import Tag from '@/views/websites/Tag.vue'
import Templates from '@/views/websites/Templates.vue'
import Template from '@/views/websites/Template.vue'
import TemplatePages from '@/views/websites/TemplatePages.vue'
import TemplatePage from '@/views/websites/TemplatePage.vue'
import PageTemplates from '@/views/websites/PageTemplates.vue'
import Units from '@/views/websites/Units.vue'
import UnitsActivate from '@/views/websites/UnitsActivate.vue'
import Unit from '@/views/websites/Unit.vue'
import Websites from '@/views/websites/Websites.vue'
import Website from '@/views/websites/Website.vue'

import * as Breadcrumbs from '../breadcrumbs/website'

export default [
	{
		path: '/string-categories',
		name: 'string-categories',
		component: StringCategories,
		meta: {
			requiresAuth: true,
			title: 'String Categories',
			breadcrumb: [
				Breadcrumbs.StringCategories,
			],
		},
	},
	{
		path: '/string-category',
		name: 'string-category',
		component: StringCategory,
		meta: {
			requiresAuth: true,
			title: 'String Categories',
			breadcrumb: [
				Breadcrumbs.StringCategories,
				Breadcrumbs.StringCategory,
			],
		},
	},
	{
		path: '/websites',
		name: 'websites',
		component: Websites,
		meta: {
			requiresAuth: true,
			title: 'Websites',
			breadcrumb: [
				Breadcrumbs.Websites,
			],
		},
	},
	{
		path: '/websites/:website',
		name: 'website',
		component: Website,
		meta: {
			requiresAuth: true,
			title: 'Websites',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Website,
			],
		},
	},
	{
		path: '/websites/:website/assets',
		name: 'website-assets',
		component: Assets,
		meta: {
			requiresAuth: true,
			title: 'Website Assets',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Assets,
			],
		},
	},
	{
		path: '/websites/:website/assets/:asset',
		name: 'website-asset',
		component: Asset,
		meta: {
			requiresAuth: true,
			title: 'Website Assets',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Assets,
				Breadcrumbs.Asset,
			],
		},
	},
	{
		path: '/websites/:website/complexes',
		name: 'website-complexes',
		component: Complexes,
		meta: {
			requiresAuth: true,
			title: 'Website Complexes',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Complexes,
			],
		},
	},
	{
		path: '/websites/:website/complexes/activate',
		name: 'website-complexes-activate',
		component: ComplexesActivate,
		meta: {
			requiresAuth: true,
			title: 'Website Complexes',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Complexes,
				Breadcrumbs.ComplexesActivate,
			],
		},
	},
	{
		path: '/websites/:website/complexes/:complex',
		name: 'website-complex',
		component: Complex,
		meta: {
			requiresAuth: true,
			title: 'Website Complexes',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Complexes,
				Breadcrumbs.Complex,
			],
		},
	},
	{
		path: '/websites/:website/images',
		name: 'website-images',
		component: Images,
		meta: {
			requiresAuth: true,
			title: 'Website Images',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Images,
			],
		},
	},
	{
		path: '/websites/:website/images/:image',
		name: 'website-image',
		component: Image,
		meta: {
			requiresAuth: true,
			title: 'Website Images',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Images,
				Breadcrumbs.Image,
			],
		},
	},
	{
		path: '/websites/:website/namespaces',
		name: 'website-namespaces',
		component: Namespaces,
		meta: {
			requiresAuth: true,
			title: 'Website Namespaces',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Namespaces,
			],
		},
	},
	{
		path: '/websites/:website/namespaces/:namespace',
		name: 'website-namespace',
		component: Namespace,
		meta: {
			requiresAuth: true,
			title: 'Website Namespaces',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Namespaces,
				Breadcrumbs.Namespace,
			],
		},
	},
	{
		path: '/websites/:website/navitems',
		name: 'website-navitems',
		component: NavItems,
		meta: {
			requiresAuth: true,
			title: 'Website Navigation',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.NavItems,
			],
		},
	},
	{
		path: '/websites/:website/navitems/:item',
		name: 'website-navitem',
		component: NavItem,
		meta: {
			requiresAuth: true,
			title: 'Website Navigation',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.NavItems,
				Breadcrumbs.NavItem,
			],
		},
	},
	{
		path: '/websites/:website/pages',
		name: 'website-pages',
		component: Pages,
		meta: {
			requiresAuth: true,
			title: 'Website Pages',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Pages,
			],
		},
	},
	{
		path: '/websites/:website/pages/:page',
		name: 'website-page',
		component: Page,
		meta: {
			requiresAuth: true,
			title: 'Website Pages',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Pages,
				Breadcrumbs.Page,
			],
		},
	},
	{
		path: '/websites/:website/redirections',
		name: 'website-redirections',
		component: Redirections,
		meta: {
			requiresAuth: true,
			title: 'Website Redirections',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Redirections,
			],
		},
	},
	{
		path: '/websites/:website/redirections/:redirection',
		name: 'website-redirection',
		component: Redirection,
		meta: {
			requiresAuth: true,
			title: 'Website Redirections',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Redirections,
				Breadcrumbs.Redirection,
			],
		},
	},
	{
		path: '/websites/:website/strings',
		name: 'website-strings',
		component: Strings,
		meta: {
			requiresAuth: true,
			title: 'Website Strings',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Strings,
			],
		},
	},
	{
		path: '/websites/:website/strings/:string',
		name: 'website-string',
		component: String,
		meta: {
			requiresAuth: true,
			title: 'Website String',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Strings,
				Breadcrumbs.String,
			],
		},
	},
	{
		path: '/websites/:website/tags',
		name: 'website-tags',
		component: Tags,
		meta: {
			requiresAuth: true,
			title: 'Website Tags',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Tags,
			],
		},
	},
	{
		path: '/websites/:website/tags/:tag',
		name: 'website-tag',
		component: Tag,
		meta: {
			requiresAuth: true,
			title: 'Website Tags',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Tags,
				Breadcrumbs.Tag,
			],
		},
	},
	{
		path: '/websites/:website/units',
		name: 'website-units',
		component: Units,
		meta: {
			requiresAuth: true,
			title: 'Website Units',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Units,
			],
		},
	},
	{
		path: '/websites/:website/units/activate',
		name: 'website-units-activate',
		component: UnitsActivate,
		meta: {
			requiresAuth: true,
			title: 'Website Units',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Units,
				Breadcrumbs.UnitsActivate,
			],
		},
	},
	{
		path: '/websites/:website/units/:unit',
		name: 'website-unit',
		component: Unit,
		meta: {
			requiresAuth: true,
			title: 'Website Units',
			breadcrumb: [
				Breadcrumbs.Websites,
				Breadcrumbs.Units,
				Breadcrumbs.Unit,
			],
		},
	},

	/* Website Templates */
	{
		path: '/website-templates',
		name: 'website-templates',
		component: Templates,
		meta: {
			requiresAuth: true,
			title: 'Templates',
			breadcrumb: [
				Breadcrumbs.Templates,
			],
		},
	},
	{
		path: '/website-templates/:template',
		name: 'website-template',
		component: Template,
		meta: {
			requiresAuth: true,
			title: 'Templates',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.Template,
			],
		},
	},
	{
		path: '/website-templates/:template/namespaces',
		name: 'website-template-namespaces',
		component: Namespaces,
		meta: {
			requiresAuth: true,
			title: 'Template Namespaces',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.TemplateNamespaces,
			],
		},
	},
	{
		path: '/website-templates/:template/namespaces/:namespace',
		name: 'website-template-namespace',
		component: Namespace,
		meta: {
			requiresAuth: true,
			title: 'Template Namespaces',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.TemplateNamespaces,
				Breadcrumbs.TemplateNamespace,
			],
		},
	}, {
		path: '/website-templates/:template/pages',
		name: 'website-template-pages',
		component: TemplatePages,
		meta: {
			requiresAuth: true,
			title: 'Template Fixed Pages',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.TemplatePages,
			],
		},
	}, {
		path: '/website-templates/:template/pages/:page',
		name: 'website-template-page',
		component: TemplatePage,
		meta: {
			requiresAuth: true,
			title: 'Template String',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.TemplatePages,
				Breadcrumbs.TemplatePage,
			],
		},
	}, {
		path: '/website-templates/:template/pagetemplates',
		name: 'website-template-pagetemplates',
		component: PageTemplates,
		meta: {
			requiresAuth: true,
			title: 'Template Page Templates',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.PageTemplates,
			],
		},
	}, {
		path: '/website-templates/:template/strings',
		name: 'website-template-strings',
		component: Strings,
		meta: {
			requiresAuth: true,
			title: 'Template Strings',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.TemplateStrings,
			],
		},
	},
	{
		path: '/website-templates/:template/strings/:string',
		name: 'website-template-string',
		component: String,
		meta: {
			requiresAuth: true,
			title: 'Template String',
			breadcrumb: [
				Breadcrumbs.Templates,
				Breadcrumbs.TemplateStrings,
				Breadcrumbs.TemplateString,
			],
		},
	},
]
